export const listTopLevelDomains = `
   query listTopLevelDomains($filter: TopLevelDomainsFilterInput, $limit: Int, $nextToken: String) {
       listTopLevelDomains(filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                 id
                 name
                 tldType
                 tldManager
                 created
                 updated
            }
       }
   }
`

export const getTopLevelDomain = `
   query getTopLevelDomain($id:ID!) {
         getTopLevelDomain(id:$id) {
            id
            name
            tldType
            tldManager
            created
            updated
         }
}`